import   React              from "react";

import   classNames         from "classnames";

import   styles              from "./SentEmailManagment.module.scss";

import   SentEmailList       from "./SentEmailList";

import { useTypedSelector  } from "../../../store/useTypeSelector";
import { RootState         } from "../../../store/generalReducer";

export interface SentEmailManagmentProps {
  email?: string;
}

// Onglet "Emails envoyés" : historique des emails reçus par le créateur — scopé sur
// `email` s'il est fourni (fiche d'un créateur ouverte par un superadmin), sinon sur
// authentication.admin.email (compte connecté), même pattern que SubscriptionManagment.
export const SentEmailManagment: React.FC<SentEmailManagmentProps> = ({ email: emailProp }) => {

  const { authentication } = useTypedSelector((state: RootState) => state.authenticationReducer);

  const email = emailProp ?? authentication.admin?.email;

  if (!email) {
    return (
      <div className={classNames(styles.root)}>
        Chargement du profil...
      </div>
    );
  }

  return (
    <div className={classNames(styles.root)}>
      <SentEmailList userEmail={email} />
    </div>
  );
};

export default SentEmailManagment;
